import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const BadgeFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M12 20.9184C7.08163 20.9184 3 16.8571 3 11.9592C3 7.06122 7.08163 3 12 3C16.9184 3 21 7.06122 21 11.9592C21 16.8571 16.9184 20.9184 12 20.9184ZM13.3478 10.0846L12.0002 5.93701L10.6526 10.0846H6.29158L9.8197 12.6479L8.47208 16.7955L12.0002 14.2321L15.5283 16.7955L14.1807 12.6479L17.7088 10.0846H13.3478Z"
      />
    </SvgIcon>
  );
});
